import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  InputGroup,
} from "@themesberg/react-bootstrap";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import swal from "sweetalert";
import axios from "axios";
import {
  createProjectAnnoucement,
  getProjectAnnoucement,
  updateProjectAnnoucement,
} from "../../app/api";
import { useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import { useHistory } from "react-router-dom";
import { Routes } from "../../routes";
import Loadericon from "../../components/Loadericon";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
export default () => {
  const { id } = useParams();
  const [deadline, setDeadline] = useState("");
  const history = useHistory();

  const [status, setStatus] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "image",
  ];
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingBtn(true);
    try {
      const token = localStorage.getItem("token");
      const formattedFromDate = moment(deadline).format("YYYY-MM-DD HH:mm:ss");

      const ProjectAnnoucement = {
        deadline: formattedFromDate,
        description,
        active: status,
        title,
      };
      let response;
      if (id) {
        response = await axios.put(
          updateProjectAnnoucement(id),
          ProjectAnnoucement,
          {
            headers: {
              "Content-Type": "application/json", // Set Content-Type to application/json
              "secret-key": process.env.REACT_APP_SECRET_KEY, // Include the secret-key
              "auth-token": `Bearer ${token}`,
            },
          }
        );
        swal({
          text: response.data.message,
          icon: "success",
        }).then(() => {
          history.push(Routes.ProjectAnnoucement.path);
        });
      } else {
        response = await axios.post(
          createProjectAnnoucement(),
          ProjectAnnoucement,
          {
            headers: {
              "Content-Type": "application/json", // Set Content-Type to application/json
              "secret-key": process.env.REACT_APP_SECRET_KEY, // Include the secret-key
              "auth-token": `Bearer ${token}`,
            },
          }
        );
        swal({
          text: response.data.message,
          icon: "success",
        });
      }
      
        setDeadline("");
        setStatus("");
        setTitle("");
        setDescription("");
      
      // console.log(response.data);
    } catch (error) {
      swal({
        text:  error.response.data.messages.error,
        icon: "error",
      });
    } finally {
      setLoadingBtn(false);
     
    }
  };
  const fetchSingleProject = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(getProjectAnnoucement(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      setDeadline(response.data?.announcement?.deadline);
      setStatus(response.data?.announcement?.active);
      setTitle(response.data?.announcement?.title);
      setDescription(response.data?.announcement?.description);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSingleProject();
  }, [id]);
  const handleBackClick = () => {
    history.push(Routes.ProjectAnnoucement.path);
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
            <div className="d-block  mb-md-0">
              {/* <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Back</Breadcrumb.Item>
            <Breadcrumb.Item active>{id?"Project Announcement":"Project Announcement"}</Breadcrumb.Item>
          </Breadcrumb> */}
              <h4 className="mb-0">Project Announcement</h4>
            </div>
          </div>

          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                  <Card.Title>
                    {id
                      ? "Update Project Announcement"
                      : "Create a New Project Announcement"}
                  </Card.Title>

                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group id="Title">
                          <Form.Label>Title</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mb-3">
                        <Form.Group id="status">
                          <Form.Label>Status</Form.Label>
                          <Form.Select
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                          >
                            <option value="Null">Select Status</option>
                            <option value="1">Active</option>
                            <option value="0">InActive</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} className="mb-3">
                        <Form.Group id="Deadline Date">
                          <Form.Label>Deadline</Form.Label>
                          <Datetime
                            timeFormat={false}
                            onChange={(e) => setDeadline(e)}
                            renderInput={(props, openCalendar) => (
                              <InputGroup>
                                <InputGroup.Text>
                                  <FontAwesomeIcon icon={faCalendarAlt} />
                                </InputGroup.Text>
                                <Form.Control
                                  required
                                  type="text"
                                  value={
                                    deadline
                                      ? moment(deadline).format("MM/DD/YYYY")
                                      : ""
                                  }
                                  placeholder="mm/dd/yyyy"
                                  onFocus={openCalendar}
                                  onChange={() => {}}
                                />
                              </InputGroup>
                            )}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} className="mb-3">
                        <Form.Group id="Description">
                          <Form.Label>Description</Form.Label>
                          <ReactQuill
                            theme="snow" // Use the Snow theme
                            value={description}
                            onChange={setDescription}
                            modules={modules}
                            formats={formats}
                            placeholder="Enter Description"
                            style={{
                              border: "0.0625rem solid #d1d7e0",
                              borderRadius: "0.5rem",
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-between">
                      <Button
                        variant="primary"
                        onClick={handleBackClick}
                        className=" me-2"
                      >
                        <span>Back</span>
                      </Button>

                      {loadingBtn ? (
                        <div className="d-flex justify-content-start">
                          <Loadericon />
                        </div>
                      ) : (
                        <Button
                          type="submit"
                          variant="primary"
                          className=" me-2"
                        >
                          <span>Save</span>
                        </Button>
                      )}
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};
